export default __webpack_public_path__ + "media/images/clients-06-150x150-7aa6d0e946bea54b3bb700065a8866b5.png";